module.exports = __webpack_public_path__ + "static/media/ipad-svgrepo-com.0a333f25.svg";